/* global $ */

window.addEventListener('message', function (event) {
  if (typeof event.data === 'object' && typeof event.data.event === 'string') {
    const handlers = {
      'auth-ga': handleGASyncEvent,
      'auth-gwt': handleGWTSyncEvent,
      'auth-fb': handleFBSyncEvent
    };

    const handler = handlers[event.data.event];
    if (handler) {
      handler(event.data);
    }
  }
});

function handleFBSyncEvent (data) {
  if (!data.name) {
    return;
  }

  const $container = $('.js-fb-settings-container');
  const showOnRes = $container.find('.js-show-on-push-res');
  const hideOnRes = $container.find('.js-hide-on-push-res');
  const syncedText = $container.find('.js-fb-synced-text');

  showOnRes.removeClass('hidden');
  hideOnRes.addClass('hidden');
  syncedText.val(data.name);
}

function handleGASyncEvent (data) {
  if (!data.webPropertyId || !data.name || !data.email) {
    return;
  }

  const $container = $('.js-ga-settings-container');
  const $showOnRes = $container.find('.js-show-on-push-res');
  const $hideOnRes = $container.find('.js-hide-on-push-res');
  const $syncedText = $container.find('.js-ga-synced-text');

  $showOnRes.removeClass('hidden');
  $hideOnRes.toggleClass('hidden', true);
  $syncedText.val(`${data.email} - ${data.name} - [${data.webPropertyId}]`);
}

function handleGWTSyncEvent (data) {
  if (!data.gwtAccountEmail || !data.gwtSite) {
    return;
  }

  const $container = $('.js-gwt-settings-container');
  const showOnRes = $container.find('.js-show-on-push-res');
  const hideOnRes = $container.find('.js-hide-on-push-res');
  const syncedText = $container.find('.js-gwt-synced-text');

  showOnRes.removeClass('hidden');
  hideOnRes.addClass('hidden');
  syncedText.val(`${data.gwtAccountEmail} - ${data.gwtSite}`);
}

function windowOpen (dataURL) {
  return window.open(
    dataURL,
    '_blank',
    'directories=no,' + 'titlebar=no,' + 'toolbar=no,' + 'location=no,' +
    'status=no,' + 'menubar=no,' + 'scrollbars=no,' + 'resizable=no,' +
    'height=600,' + 'width=900'
  );
}

$('.load-in-modal').on('click', function (event) {
  event.preventDefault();

  const $this = $(this);
  const authUrl = $this.attr('data-auth-url');

  if (!authUrl) {
    return;
  }

  return windowOpen(authUrl);
});
